import { useConnections } from "@/shared/api/apps";

/** The agent's connected apps, one per app: what the sidebar's row and the composer's setup box stack. */
export function useAgentApps(agentId: string) {
  const { data: connections = [] } = useConnections(agentId);
  return [...new Map(connections
    .filter((connection) => connection.status === "connected")
    .map(({ app }) => [app.slug, app])).values()];
}
